import { useQuery } from '@apollo/client';
import { GET_ME } from '../queries/getMe';

export const useIsPartnerLeadership = () => {
  const { data, loading, error } = useQuery(GET_ME);
  if (loading || error) return false;
  return data?.me?.organisation?.membership?.isPartnerLeadership ?? false;
};
